import api from '../../services/api';
import { Creators } from '../ducks/city';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getCities({ filter }) {
  try {
    let response;

    yield put(Creators.cityRequest());
    response = yield call(api.post, 'city', filter);

    yield put(Creators.citySuccess(filter.chip, response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.cityError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao buscar os municípios'
    }));
  }
}